import {Component, Input} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DropdownOption} from "../../../../../models/dropdown-option.model";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {CommonService} from "../../../../shared/services/common.service";
import {MatDialog} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {
  SendSurveyFiltersComponent
} from "../send-survey-filters/send-survey-filters.component";
import {screenType} from "../../../../shared/core/shared.selectors";
import {
  CloseSurveyRequest,
  EditSurveyDataForEditScreenRequest,
  FetchClinicsOptionsListRequest,
  FetchGenderOptionsListRequest,
  FetchGroupsOptionsListRequest,
  FetchGroupStatusOptionsListRequest,
  FetchRolesOptionsListRequest,
  FetchScheduleAccordingToListForCreateSurveyRequest,
  FetchSessionListForCreateSurveyRequest
} from "../../core/questionnaires.actions";
import {
  FetchClinicListForFilters,
  fetchEditSurveyQuestionnairesDetails,
  FetchGenderListForFilters,
  FetchGroupListForFilters,
  FetchGroupStatusListForFilters,
  FetchRolesListForFilters,
  FetchScheduleAccordingToList,
  SessionDetailsForCreateSurvey
} from "../../core/questionnaires.selectors";
import {
  QuestionnaireDetails
} from "../../models/fetch-questionnaires-list.model";
import {QuestionnaireConstant} from '../../constants/questionnaire.enum';
import * as moment from 'moment'
import {roles} from 'src/app/modules/shared/constants/common.constants';

@Component({
  selector: 'app-edit-settings',
  templateUrl: './edit-settings.component.html',
  styleUrls: ['./edit-settings.component.css']
})
export class EditSettingsComponent {
  @Input() loggedInUserRole: number = null;
  @Input() clientId: string = ''
  @Input() groupId: string = ''
  form: FormGroup = new FormGroup({
    roles: new FormControl([], []),
    clientIds: new FormControl([], []),
    groupIds: new FormControl([], []),
    groupStatus: new FormControl([]),
    gender: new FormControl([]),
    unSafeZone: new FormControl([]),
    scheduleAccordingTo: new FormControl([]),
    clientSearch: new FormControl(''),
    groupSearch: new FormControl('')
  });

  surveyStatusMap = {
    draft: 1,
    open: 2,
    closed: 3
  }

  scheduleAccordingToMap = {
    session: 1,
    custom: 2
  }

  roleMap = roles

  surveyDetails: QuestionnaireDetails
  clientIdAllSelected: boolean = false;
  groupIdAllSelected: boolean = false;

  sessionDropDownOptions: DropdownOption[] = []
  sessionLoading: boolean = false

  scheduleAccordingToOptions: DropdownOption[] = []
  scheduleAccordingToLoading: boolean = false

  groupStatusOptions: DropdownOption[] = []
  groupStatusLoading: boolean = false

  genderOptions: DropdownOption[] = []
  genderLoading: boolean = false


  rolesOptions: DropdownOption[] = []
  rolesLoading: boolean = false

  clinicsOptions: DropdownOption[] = []
  clinicsLoading: boolean = false

  groupsOptions: DropdownOption[] = []
  groupsLoading: boolean = false;


  errorMessageMap: any = {
    roles: {},
    clientIds: {},
    groupIds: {},
    groupStatus: {},
    gender: {},
    unSafeZone: {},
    scheduleAccordingTo: {}
  };
  errorMessages: any = {};
  screenType: string = '';
  isSavedButtonClicked: boolean = false;
  onlySuperAdminSelected: boolean = false;
  todaysDate = moment().startOf('day');
  isFirstTimeDataLoadCompleted: boolean = false;

  /* pagination */
  clinicsHasNext: boolean = false;
  clinicsPageNumber: number = 0
  groupHasNext: boolean = false;
  groupPageNumber: number;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private matDialog: MatDialog,
    private store: Store,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(FetchRolesOptionsListRequest());
    this.store.dispatch(FetchGroupStatusOptionsListRequest());
    this.store.dispatch(FetchGenderOptionsListRequest());
    this.store.dispatch(FetchScheduleAccordingToListForCreateSurveyRequest());
    this.store.dispatch(FetchSessionListForCreateSurveyRequest());

    this.store.select(SessionDetailsForCreateSurvey)
      .pipe(takeUntil(this.onDestroy)).subscribe(sessionDetails => {
      this.sessionLoading = sessionDetails.loading;
      this.sessionDropDownOptions = sessionDetails.list;
    });

    this.store.select(FetchRolesListForFilters).pipe(takeUntil(this.onDestroy))
      .subscribe(roles => {
        this.rolesOptions = roles.list;
        this.rolesLoading = roles.loading
      });

    this.store.select(FetchGenderListForFilters).pipe(takeUntil(this.onDestroy))
      .subscribe(gender => {
        this.genderOptions = gender.list;
        this.genderLoading = gender.loading
      });

    this.store.select(FetchClinicListForFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(clinics => {
        this.clinicsOptions = clinics.list;
        this.clinicsLoading = clinics.loading;
        this.clinicsHasNext = clinics.hasNext;
        this.clinicsPageNumber = clinics.pageNumber
      });

    this.store.select(FetchGroupStatusListForFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(groupStatus => {
        this.groupStatusOptions = groupStatus.list;
        this.groupStatusLoading = groupStatus.loading;
      });

    this.store.select(screenType).pipe(takeUntil(this.onDestroy))
      .subscribe(screenType => {
        this.screenType = screenType
      })


    this.store.select(FetchScheduleAccordingToList)
      .pipe(takeUntil(this.onDestroy)).subscribe(scheduleAccordingToList => {
      this.scheduleAccordingToLoading = scheduleAccordingToList.loading;
      this.scheduleAccordingToOptions = scheduleAccordingToList.list;
      this.checkForSuperAdminSelection(this.surveyDetails?.sendTo?.roles)
    })

    this.form.get('scheduleAccordingTo').valueChanges
      .pipe(takeUntil(this.onDestroy)).subscribe(value => {
      this.addControlAccordingToSelection(value)
    });

    this.form.get('clientIds').valueChanges
      .pipe(debounceTime(1000), takeUntil(this.onDestroy))
      .subscribe((values: number[]) => {
        if (this.isFirstTimeDataLoadCompleted) {
          this.form.patchValue({
            groupIds: []
          });
          this.groupsOptions = [];
        } else {
          this.isFirstTimeDataLoadCompleted = true;
        }
        if (this.loggedInUserRole === this.roleMap.superAdmin && !this.isSavedButtonClicked && values.length > 0) {
          this.store.dispatch(FetchGroupsOptionsListRequest({
            payload: {
              clientId: values,
              pageNumber: 1,
              shouldInclude: this.form.value.groupIds
            }
          }));
        }
        this.isSavedButtonClicked = false
      });

    this.store.select(FetchGroupListForFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(group => {
        this.groupsOptions = group.list;
        this.groupsLoading = group.loading;
        this.groupHasNext = group.hasNext;
        this.groupPageNumber = group.pageNumber;
      });

    this.store.select(fetchEditSurveyQuestionnairesDetails)
      .pipe(takeUntil(this.onDestroy)).subscribe(questionnairesDetails => {
      if (Object.keys(questionnairesDetails.details).length > 0) {
        this.surveyDetails = questionnairesDetails.details;
        const updatedData = {...questionnairesDetails.details, ...questionnairesDetails.details.sendTo}
        this.checkForSuperAdminSelection(this.surveyDetails?.sendTo?.roles);
        this.addControlAccordingToSelection(questionnairesDetails.details.scheduleAccordingTo);
        if (questionnairesDetails.details.sendTo.clientIds.length > 0 && !this.isSavedButtonClicked && this.loggedInUserRole === this.roleMap.superAdmin) {
          this.store.dispatch(FetchGroupsOptionsListRequest({
            payload: {
              clientId: questionnairesDetails.details.sendTo.clientIds
            }
          }));
          this.isSavedButtonClicked = false;
        }
        this.form.patchValue({
          ...updatedData
        })

        if (this.loggedInUserRole === this.roleMap.superAdmin) {
          this.store.dispatch(FetchClinicsOptionsListRequest({
            payload: {
              pageNumber: 1, shouldInclude: updatedData?.clientIds
            }
          }));
        }

        if (questionnairesDetails.details.scheduleAccordingTo == 1) {
          this.form.patchValue({
            session: questionnairesDetails.details.sendTo.sessionId
          })
        }
        if (questionnairesDetails.details.scheduleAccordingTo == 2) {
          const activeFrom = moment(questionnairesDetails.details.activeFrom)
          const activeTo = moment(questionnairesDetails.details.activeTo)
          this.form.patchValue({
            activeFrom: activeFrom,
            activeTo: activeTo
          })
        }
        if ((this.surveyDetails?.status?.key === QuestionnaireConstant.closedStatus || this.surveyDetails.respondentsCount > 0) || this.groupId || this.clientId) {
          this.form.disable();
        }
      }
    })

    this.form.get('roles').valueChanges.pipe(takeUntil(this.onDestroy))
      .subscribe(role => {
        this.checkForSuperAdminSelection(role)
      })
    
      this.form.controls['clientSearch'].valueChanges.pipe(takeUntil(this.onDestroy), debounceTime(1000))
      .subscribe(value => {
        this.searchClient();
      })

    this.form.controls['groupSearch'].valueChanges.pipe(takeUntil(this.onDestroy), debounceTime(1000))
      .subscribe(value => {
        this.searchGroup();
      })
  }

  searchClient() {
    this.store.dispatch(FetchClinicsOptionsListRequest({
      payload: {pageNumber: 1, shouldInclude: this.form.value.clientIds, search: this.form.value.clientSearch}
    }));
  }

  searchGroup() {
    this.store.dispatch(FetchGroupsOptionsListRequest({
      payload: {
        pageNumber: 1,
        clientId: this.form.value.clientIds,
        shouldInclude: this.form.value.groupIds,
        search: this.form.value.groupSearch
      }
    }));
  }

  checkForSuperAdminSelection(role = this.form.value.roles) {
    if (role.length === 1 && role.includes(this.roleMap.superAdmin)) {
      this.onlySuperAdminSelected = true
      const updatedSession: DropdownOption[] = this.scheduleAccordingToOptions.map(res => res.key === 1 ? {...res, disabled: true} : {...res});
      this.scheduleAccordingToOptions = JSON.parse(JSON.stringify(updatedSession))
      this.form.patchValue({
        scheduleAccordingTo: this.form.value.scheduleAccordingTo === 1 ? '' : this.form.value.scheduleAccordingTo,
        clientIds: [],
        groupIds: [],
        groupStatus: []
      })
    } else {
      this.onlySuperAdminSelected = false
      this.scheduleAccordingToOptions = this.scheduleAccordingToOptions.map(res => ({...res, disabled: false}))
    }

  }

  addControlAccordingToSelection(value: number) {
    if (!value) {
      if (this.form.get('activeTo') && this.form.get('activeFrom')) {
        this.form.removeControl('activeTo')
        this.form.removeControl('activeFrom')
        const errorMap = {...this.errorMessageMap}
        delete errorMap.activeTo
        delete errorMap.activeFrom
        this.errorMessageMap = {...errorMap}
      }
      if (this.form.get('session')) {
        this.form.removeControl('session')
        const errorMap = {...this.errorMessageMap}
        delete errorMap.session
        this.errorMessageMap = {...errorMap}
      }
    } else {
      if (value === 1) {
        const control: FormControl = new FormControl('', [Validators.required])
        this.errorMessageMap = {
          ...this.errorMessageMap,
          session: {
            required: 'This field is required.',
          },
        }
        if (this.form.get('activeTo') && this.form.get('activeFrom')) {
          this.form.removeControl('activeTo')
          this.form.removeControl('activeFrom')
          const errorMap = {...this.errorMessageMap}
          delete errorMap.activeTo
          delete errorMap.activeFrom
          this.errorMessageMap = {...errorMap}
        }
        this.form.addControl('session', control)
      } else {
        const fromControl: FormControl = new FormControl('', [Validators.required])
        const toControl: FormControl = new FormControl('', [Validators.required])
        this.errorMessageMap = {
          ...this.errorMessageMap,
          activeFrom: {
            required: 'This field is required.',
          },
          activeTo: {
            required: 'This field is required.',
          },
        }
        if (this.form.get('session')) {
          this.form.removeControl('session')
          const errorMap = {...this.errorMessageMap}
          delete errorMap.session
          this.errorMessageMap = {...errorMap}
        }
        this.form.addControl('activeFrom', fromControl)
        this.form.addControl('activeTo', toControl)
        this.form.controls['activeFrom'].valueChanges
          .pipe(takeUntil(this.onDestroy))
          .subscribe(value => {
            if (this.form.controls['activeTo'].value && !moment(this.form.controls['activeTo'].value)
              .isSameOrAfter(value)) {
              this.form.patchValue({
                activeTo: null
              })
            }
          })
      }
    }

  }


  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }


  saveButtonClicked() {
    this.isSavedButtonClicked = true;
    let skipValidityCheck = false;

    for (let controlName in this.form.controls) {
      if (controlName === 'activeFrom' && this.form.controls['activeFrom'].status === 'INVALID') {
        skipValidityCheck = true
      }
    }

    if (this.form.invalid && !skipValidityCheck) {
      this.checkForErrors();
      $("html")
        .scrollTop($($(".form-field.ng-invalid")?.[0])?.offset()?.top - 25);
      return;
    }

    const updatedDataForSurveyEdit: QuestionnaireDetails = {
      scheduleAccordingTo: this.form.value.scheduleAccordingTo ? this.form.value.scheduleAccordingTo : null,
      activeFrom: this.form.value.activeFrom ? this.form.value.activeFrom : null,
      activeTo: this.form.value.activeTo ? this.form.value.activeTo : null,
      sendTo: {
        gender: this.form.value.gender ? this.form.value.gender : null,
        roles: this.form.value.roles ? this.form.value.roles : null,
        clientIds: this.form.value.clientIds ? this.form.value.clientIds : null,
        groupIds: this.form.value.groupIds ? this.form.value.groupIds : null,
        groupStatus: this.form.value.groupStatus ? this.form.value.groupStatus : null,
        sessionId: this.form.value.session ? this.form.value.session : null
      },
      status: QuestionnaireConstant.openStatus
    }
    this.isFirstTimeDataLoadCompleted = false;
    this.store.dispatch(EditSurveyDataForEditScreenRequest({payload: {surveyDetails: {...updatedDataForSurveyEdit, id: this.surveyDetails.id}}}))
  }

  filterButtonClicked() {
    this.matDialog.open(SendSurveyFiltersComponent, {
      width: this.screenType === 'mobile' ? '100%' : '60%', minHeight: '60%',
    })
  }

  closeSurveyButtonClicked() {
    this.store.dispatch(CloseSurveyRequest({payload: {surveyId: +this.surveyDetails.id}}))
  }

  fetchClinicsNextPageOptions() {
    this.store.dispatch(FetchClinicsOptionsListRequest({payload: {
      pageNumber: this.clinicsPageNumber + 1,
      ...(this.form.value.clientSearch ? {search: this.form.value.clientSearch} : {}),
      ...(this.form.value.clientIds? {shouldInclude: this.form.value.clientIds}:{})
    }}));
  }

  fetchGroupsNextPageOptions() {
    this.store.dispatch(FetchGroupsOptionsListRequest({
      payload: {
        pageNumber: this.groupPageNumber + 1,
        clientId: this.form.value.clientIds,
        ...(this.form.value.groupSearch ? {search: this.form.value.groupSearch} : {}),
        ...(this.form.value.groupIds? {shouldInclude: this.form.value.groupIds}:{})
      }
    }));
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
